// components/Navbar.js
function Navbar() {
    return (
        <nav>
            {/* Lag navbar hvis jeg har tid */}
        </nav>
    );
}

export default Navbar;